export default class InstructorCategory {
    Id: number = 0;
    Name: string = '';
    Status: number = 0;
}
